import { InputTextAreaField } from '@tempmee/react';
import type { InputTextAreaFieldProps } from '@tempmee/react';

/**
 * App-level wrapper around the DS InputTextAreaField with a sensible default height.
 *
 * Implementation note: InputTextAreaField internally does:
 *   <textarea style={height !== void 0 ? { height } : void 0} {...props} />
 * A `style` key inside `...props` overwrites the height style, so we own
 * the full style merge here and skip passing the `height` prop separately.
 */
interface TextAreaFieldProps extends Omit<InputTextAreaFieldProps, 'height'> {
  height?: number;
}

export function TextAreaField({ height = 200, style, ...props }: TextAreaFieldProps) {
  return (
    <InputTextAreaField
      style={{
        height,
        border: 'none',
        ...style,
      }}
      {...props}
    />
  );
}
